// Polyfill for older browsers
if (!window.structuredClone) {
  window.structuredClone = (obj: any) => {
    return JSON.parse(JSON.stringify(obj));
  };
}

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';

// Error handling for unhandled promise rejections
window.addEventListener('unhandledrejection', event => {
  console.error('Unhandled promise rejection:', event.reason);
});

// Error handling for runtime errors
window.addEventListener('error', event => {
  console.error('Runtime error:', event.error);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
